import { IModelContext } from "../../models/IModelContext";
import { IPanelContext } from "../../models/IPanelContext";
import { RuleViolationModel } from "../../../../common/models/RuleViolationModel";

export class RuleViolationDetailModel {
    constructor(public panel: IPanelContext,public fieldIndex: number, public  field: IModelContext,public ruleViolations: RuleViolationModel[], public summaryMessage?: string){}
}


// WEBPACK FOOTER //
// ./src/app/pillar/workspace/components/rule-violation-details/ruleViolationDetailModel.ts